import { CHARACTER_WIDTH, ICON_OFFSET } from "../constants";
export var getMinWidth = function getMinWidth(isSearchable, items) {
  if (!isSearchable) return;
  var longestItem = items.reduce(function (accumulator, _ref) {
    var text = _ref.text;
    return accumulator.length > text.length ? accumulator : text;
  }, '');
  return {
    minWidth: longestItem.length * CHARACTER_WIDTH + ICON_OFFSET
  };
};